import type { AnswerState, StoreState } from '../../state-types';
import { makeSurveyDirty } from '../utils/make-survey-dirty';

/** Update an answer partially */
export const updateAnswer =
    (answerId: string, partialAnswer: Partial<AnswerState>) =>
    (state: StoreState) => {
        return makeSurveyDirty({
            ...state,
            answers: {
                ...state.answers,
                [answerId]: {
                    ...state.answers[answerId],
                    ...partialAnswer,
                },
            },
        });
    };
